module.exports = __webpack_public_path__ + "img/banner.a6eb79e0.jpg";